// 0001-01-01T00:00Z
export var MIN_DATE = new Date(-62135596800000.0);
// 275760-09-13T00:00Z
export var MAX_DATE = new Date(8640000000000000.0);
